import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmbellishmentEnvService } from './embellishment-env.service';
import {
  TREQUEST_EMB_LANDING_COUNT,
  TRESPONSE_EMB_LANDING_COUNT,
  TEmbType,
  TREQUEST_EMB_SENT_CREATE,
  TRESPONSE_EMB_CRUD_OPERATIONS,
  ITagBctx,
  TEmbListType,
  TREQUEST_EMB_LOG_LISTING_DETAILS,
  TRESPONSE_EMB_LOG_LISTING_DETAILS,
  TRESPONSE_EMB_SENT_TAG_DETAILS,
  TREQUEST_EMB_SENT_TAG_DETAILS,
  TREQUEST_EMB_LOG_LISTING,
  TRESPONSE_EMB_LOG_LISTING,
  TREQUEST_EMB_REMOVE_TRANSACTION,
  TREQUEST_EMB_RECEIVE_CREATE,
  TREQUEST_EMB_REMOVE_TAG,
  TRESPONSE_EMB_RECEIVE_GET_DEFECTIVES,
  TREQUEST_EMB_RECEIVE_UPDATE_DEFECTIVES,
  TRESPONSE_EMB_RECEIVE_UPDATE_DEFECTIVES,
  TREQUEST_EMB_RECEIVE_UPDATE,
} from '@monorepo/types';
@Injectable({
  providedIn: 'root',
})
export class EmbellishmentDataService {
  constructor(private embellishmentEnvService: EmbellishmentEnvService, private http: HttpClient) {}
  makeEmbLandingCountRequest(app_type: TEmbType, postBody: TREQUEST_EMB_LANDING_COUNT) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_LANDING_COUNT').replace(':embType', app_type);
    return this.http.post<TRESPONSE_EMB_LANDING_COUNT>(url, postBody);
  }
  getComponentTagDetails(displayTagId: string, subject_key: string) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_GET_COMPONENT_TAG_DETAILS');
    return this.http.post<ITagBctx[]>(url, {
      subject_key: subject_key,
      displayTag: displayTagId,
    });
  }
  createEmbSent(postBody: TREQUEST_EMB_SENT_CREATE) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_SENT_CREATE');
    return this.http.post<TRESPONSE_EMB_CRUD_OPERATIONS>(url, postBody);
  }
  getEmbSentTagDetails(postBody: TREQUEST_EMB_SENT_TAG_DETAILS) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_SENT_TAG_DETAILS');
    return this.http.post<TRESPONSE_EMB_SENT_TAG_DETAILS>(url, postBody);
  }
  createEmbReceive(postBody: TREQUEST_EMB_RECEIVE_CREATE) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_RECEIVE_CREATE');
    return this.http.post<TRESPONSE_EMB_CRUD_OPERATIONS>(url, postBody);
  }
  getEmbLogListing(postBody: TREQUEST_EMB_LOG_LISTING, listType: TEmbListType, app_type: TEmbType) {
    const url = this.embellishmentEnvService
      .getEnvVar('EMB_LOG_LISTING')
      .replace(':embType', app_type)
      .replace(':listType', listType);
    return this.http.post<TRESPONSE_EMB_LOG_LISTING>(url, postBody);
  }
  removeTransaction(postBody: TREQUEST_EMB_REMOVE_TRANSACTION, app_type: TEmbType) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_REMOVE_TRANSACTION').replace(':embType', app_type);
    return this.http.post<TRESPONSE_EMB_CRUD_OPERATIONS>(url, postBody);
  }
  fetchEmbLogListingDetails(postBody: TREQUEST_EMB_LOG_LISTING_DETAILS, listType: TEmbListType, app_type: TEmbType) {
    const url = this.embellishmentEnvService
      .getEnvVar('EMB_LOG_LISTING_DETAILS')
      .replace(':embType', app_type)
      .replace(':listType', listType);
    return this.http.post<TRESPONSE_EMB_LOG_LISTING_DETAILS>(url, postBody);
  }
  removeTag(postBody: TREQUEST_EMB_REMOVE_TAG, app_type: TEmbType) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_REMOVE_TAG').replace(':embType', app_type);
    return this.http.post<TRESPONSE_EMB_CRUD_OPERATIONS>(url, postBody);
  }
  getDefectiveList(postBody: TREQUEST_EMB_REMOVE_TAG) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_RECEIVE_GET_DEFECTIVES');
    return this.http.post<TRESPONSE_EMB_RECEIVE_GET_DEFECTIVES>(url, postBody);
  }
  updateDefectiveList(postBody: TREQUEST_EMB_RECEIVE_UPDATE_DEFECTIVES) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_RECEIVE_UPDATE_DEFECTIVES');
    return this.http.post<TRESPONSE_EMB_RECEIVE_UPDATE_DEFECTIVES>(url, postBody);
  }
  updateEmbReceive(postBody: TREQUEST_EMB_RECEIVE_UPDATE) {
    const url = this.embellishmentEnvService.getEnvVar('EMB_RECEIVE_UPDATE');
    return this.http.post<TRESPONSE_EMB_CRUD_OPERATIONS>(url, postBody);
  }
}
